// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"ec534a97","343":"d01291ed","914":"e7c60b4e"}[chunkId] + ".chunk.css";
};